export default __webpack_public_path__ + "static/media/error.c643190f.gif";